import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';

import { dashboardUrl, readLastOrganizationSegment } from '@/shared/utils/organization-route';

export const guestGuard: CanActivateFn = () => {
  const router = inject(Router);
  const token = localStorage.getItem('accessToken');
  const lastOrg = readLastOrganizationSegment() || '_org_';

  if (token) {
    return router.createUrlTree([dashboardUrl(lastOrg)]);
  }

  return true;
};
